import PropTypes from 'prop-types';
import UIModal from 'UIComponents/dialog/UIModal';
import UILogo from 'UIComponents/image/UILogo';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import Blob from '../utils/Blob';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { skip2FASetupNudge, select2FASetupNudge } from '../actions/TwoFactorAuthActions';
import * as TwoFactorAuthPrecedenceTypes from '../constants/TwoFactorAuthPrecedenceTypes';
import * as TwoFactorAuthMethods from '../constants/TwoFactorAuthMethods';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "TwoFactorSetupOrSkip__StyledDiv",
  componentId: "sc-1mqa1hl-0"
})(["width:128px;position:absolute;left:40px;top:15px;margin-bottom:var(--trellis-space-200);"]);
const ConfirmSkipModal = ({
  handleSkipFunction,
  handleCancelFunction
}) => {
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "danger",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.2fa.nudge.modal.title"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: handleCancelFunction
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userPreferences.2fa.nudge.modal.description"
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        use: "danger",
        onClick: handleSkipFunction,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.2fa.nudge.modal.skip"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "tertiary-light",
        onClick: handleCancelFunction,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.2fa.nudge.modal.cancel"
        })
      })]
    })]
  });
};
const TwoFactorSetupOrSkip = ({
  primaryAuthMethod
}) => {
  const [openModal, setOpenModal] = useState(false);
  const dispatch = useDispatch();
  const precedence = primaryAuthMethod ? TwoFactorAuthPrecedenceTypes.SECONDARY : TwoFactorAuthPrecedenceTypes.PRIMARY;
  const handleSetup = () => {
    dispatch(select2FASetupNudge(precedence));
  };
  const handleSkip = () => {
    if (precedence === TwoFactorAuthPrecedenceTypes.PRIMARY) {
      setOpenModal(true);
    } else {
      dispatch(skip2FASetupNudge());
    }
  };
  const handleSkipModal = () => {
    setOpenModal(false);
    dispatch(skip2FASetupNudge());
  };
  const handleCancelModal = () => {
    setOpenModal(false);
  };
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "fullscreen",
    children: [openModal && /*#__PURE__*/_jsx(ConfirmSkipModal, {
      handleSkipFunction: handleSkipModal,
      handleCancelFunction: handleCancelModal
    }), /*#__PURE__*/_jsx(StyledDiv, {
      children: /*#__PURE__*/_jsx(UILogo, {
        name: "hubspot-wordmark"
      })
    }), /*#__PURE__*/_jsxs(UIFlex, {
      direction: "row",
      justify: "center",
      align: "center",
      wrap: "wrap",
      children: [/*#__PURE__*/_jsx(UIBox, {
        basis: 525,
        shrink: 1,
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("h1", {
              children: precedence === TwoFactorAuthPrecedenceTypes.PRIMARY ? /*#__PURE__*/_jsx(FormattedMessage, {
                message: "userPreferences.2fa.nudge.title"
              }) : /*#__PURE__*/_jsx(FormattedMessage, {
                message: "userPreferences.2fa.nudge.titleSecondary"
              })
            }), /*#__PURE__*/_jsx("p", {
              children: precedence === TwoFactorAuthPrecedenceTypes.PRIMARY ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: "userPreferences.2fa.nudge.description"
              }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: "userPreferences.2fa.nudge.descriptionSecondary"
              })
            })]
          }), /*#__PURE__*/_jsx(UIButton, {
            use: "primary",
            onClick: handleSetup,
            children: precedence === TwoFactorAuthPrecedenceTypes.PRIMARY ? /*#__PURE__*/_jsx(FormattedMessage, {
              message: "userPreferences.2fa.nudge.setUp"
            }) : /*#__PURE__*/_jsx(FormattedMessage, {
              message: "userPreferences.2fa.nudge.setUpSecondary"
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            onClick: handleSkip,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "userPreferences.2fa.nudge.skip"
            })
          })]
        })
      }), /*#__PURE__*/_jsx(UIBox, {
        basis: 100
      }), /*#__PURE__*/_jsx(UIBox, {
        children: /*#__PURE__*/_jsx(Blob, {})
      })]
    })]
  });
};
TwoFactorSetupOrSkip.prototype = {
  primaryAuthMethod: PropTypes.oneOf(Object.keys(TwoFactorAuthMethods))
};
export default TwoFactorSetupOrSkip;